/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Password_Reset_Updated_TitleInputs */

const en_password_reset_updated_title = /** @type {(inputs: Password_Reset_Updated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password updated`)
};

const es_password_reset_updated_title = /** @type {(inputs: Password_Reset_Updated_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contraseña actualizada`)
};

/**
* | output |
* | --- |
* | "Password updated" |
*
* @param {Password_Reset_Updated_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const password_reset_updated_title = /** @type {((inputs?: Password_Reset_Updated_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Password_Reset_Updated_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_password_reset_updated_title(inputs)
	return en_password_reset_updated_title(inputs)
});